import { normalizePathForComparison, isDashboardPath } from '../jsx/layouts/nav/moduleNav';

/**
 * Navbar search is shown only on dashboard (global) and module list pages.
 */
const MODULE_LIST_MATCHERS = [
  {
    label: 'Dashboard',
    match: (p) => p === '/task/tasklist',
  },
  {
    label: 'Worksheet',
    match: (p) => p === '/task/worksheet',
  },
  {
    label: 'Projects',
    match: (p) =>
      p === '/task/projectlist' ||
      p === '/task/projecttasklist' ||
      p === '/task/projectdashboard',
  },
  {
    label: 'Forum',
    match: (p) => p === '/forum/list' || p === '/forum/dashboard',
  },
  {
    label: 'Documents',
    match: (p) =>
      p === '/documents/mydocuments' ||
      p.startsWith('/documents/folder/') ||
      p === '/documents/shared' ||
      p === '/documents/favorites' ||
      p === '/documents/dashboard' ||
      p === '/documents/documentclassifications',
  },
  {
    label: 'Vault',
    match: (p) =>
      p === '/credential-vault/credentialvaultlist' ||
      p === '/credential-vault/personalvaultlist',
  },
  {
    label: 'Work Register',
    match: (p) => p === '/work-register/list' || p === '/work-register/team',
  },
  {
    label: 'Users',
    match: (p) => p === '/settings/userlist',
  },
  {
    label: 'Staff',
    match: (p) => p === '/staff/stafflist',
  },
  {
    label: 'Vehicles',
    match: (p) => p === '/vehicle/vehiclelist',
  },
  {
    label: 'Branches',
    match: (p) => p === '/settings/branchlist',
  },
  {
    label: 'Departments',
    match: (p) => p === '/settings/departmentlist',
  },
  {
    label: 'Sub-Departments',
    match: (p) => p === '/settings/subdepartmentlist',
  },
  {
    label: 'Designations',
    match: (p) => p === '/settings/designationlist',
  },
  {
    label: 'Modules',
    match: (p) => p === '/modules',
  },
];

/**
 * @param {string} pathname
 * @returns {{ show: boolean, mode?: 'global'|'module', label?: string }}
 */
export function getHeaderSearchContext(pathname) {
  if (isDashboardPath(pathname)) {
    return {
      show: true,
      mode: 'global',
      label: 'all modules',
      placeholder: 'Global search across modules...',
    };
  }

  const normalized = normalizePathForComparison(pathname).toLowerCase();

  for (const item of MODULE_LIST_MATCHERS) {
    if (item.match(normalized)) {
      return {
        show: true,
        mode: 'module',
        label: item.label,
        placeholder: `Search in ${item.label}...`,
      };
    }
  }

  return { show: false };
}
